// removed by extract-text-webpack-plugin
module.exports = {"ControlBar":"ControlBar__kr04Mlh0vJKO"};